export const generals = [
  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 75,
    speed: 25,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 75,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 50,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'serif',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 55,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 20,
    speed: 65,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'serif',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 40,
    speed: 30,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 25,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 75,
    speed: 60,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 75,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 80,
    speed: 45,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'serif',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 35,
    speed: 80,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 30,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'serif',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 65,
    speed: 45,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'monospace',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 50,
    speed: 80,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'dark',
    weight: 'bold',
    size: 65,
    speed: 80,
    color: 1,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'dark',
    weight: 'regular',
    size: 65,
    speed: 85,
    color: 1,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 50,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 50,
    speed: 60,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 75,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'dark',
    weight: 'bold',
    size: 65,
    speed: 50,
    color: 1,
  },

  {
    type: 'sentence',
    font: 'serif',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 45,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 80,
    speed: 55,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 75,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 50,
    speed: 75,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 40,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 45,
    speed: 80,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 50,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'dark',
    weight: 'regular',
    size: 40,
    speed: 40,
    color: 1,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 60,
    speed: 35,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 80,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'bold',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'serif',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 65,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'italic',
    size: 65,
    speed: 45,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 30,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 35,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 30,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'dark',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 1,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 35,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'dark',
    weight: 'regular',
    size: 25,
    speed: 55,
    color: 1,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 65,
    speed: 50,
    color: 0,
  },

  {
    type: 'sentence',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 48,
    speed: 75,
    color: 0,
  },

  {
    type: 'word',
    font: 'sans',
    letterCase: 'lower',
    alignment: 'center',
    background: 'bright',
    weight: 'regular',
    size: 48,
    speed: 75,
    color: 0,
  },
];
